import type { Position } from '@/types/game';

export type TeleporterMap = Map<string, Position>;

export function positionKey(position: Position): string {
  return `${position[0]},${position[1]}`;
}

export function buildTeleporterMap(puzzleGrid: string[]): TeleporterMap {
  const teleporters: Position[] = [];

  puzzleGrid.forEach((row, y) => {
    row.split('').forEach((cell, x) => {
      if (cell.toLowerCase() === 't') teleporters.push([x, y]);
    });
  });

  const map: TeleporterMap = new Map();
  for (let i = 0; i + 1 < teleporters.length; i += 2) {
    const a = teleporters[i];
    const b = teleporters[i + 1];
    map.set(positionKey(a), b);
    map.set(positionKey(b), a);
  }
  return map;
}

export function getTeleporterDestination(map: TeleporterMap, position: Position): Position | null {
  const dest = map.get(positionKey(position));
  return dest ? ([dest[0], dest[1]] as Position) : null;
}

